export interface ScreenConfig {
    title?: string;
    isFullScreen?: boolean;
}

/**
 * Enum detonating the type of error to display
 */
export enum ErrorType {
    Network,
    Generic,
}

export interface ErrorScreenProps {
    /**
     * Screen configuration for eg, providing title
     */
    screenConfig?: ScreenConfig;

    /**
     * Callback function to perform actions when retry button is clicked
     */
    onRetry?: () => void;

    /**
     * Callback function to be called when the toast times out and goes away
     */
    onTimeout?: () => void;
}
